module.exports = __webpack_public_path__ + "static/media/company-introduction-1.abcc832c.jpg";